import React from 'react';
import styled from 'styled';

export const DensityMapContainer = styled.section`
  width: 100%;
  height: 100%;
  background-color: #000;

  .mapboxgl-ctrl-bottom-left {
    /* margin: 10px; */
    width: 100%;
    .mapboxgl-ctrl {
      margin: 0;
      float: none;
      width: 100%;
    }
  }
`;